import { useAuthSigninState } from "../../authSignin/state";
import React, { useEffect } from "react";

export const SocialLogin = () => {
    const { sendEvent } = useAuthSigninState();

    useEffect(() => {
        const socialLoginLinksBlock = document.getElementById("social-login-links-block");
        const socialLoginWrapper = document.getElementById("social-login-wrapper");

        socialLoginWrapper.innerHTML = socialLoginLinksBlock?.innerHTML;

        $('.new-social-signin-button')?.on("click", (event) => {
            sendEvent(`Social Login : ${event?.currentTarget?.getAttribute?.("data-clickedon")}`);
            // [AI GENERATED CODE] — Set pending source before OAuth redirect so createSession picks it up on return.
            if (typeof (window as any).MUS !== 'undefined') (window as any).MUS.setPendingSource('oauth');
        })
    }, [])

    return (
        <div id="social-login-wrapper"></div>
    )
}